import { axios } from '@/utils/request';

let Api = {
  getCiteReport: '/report/citeReport', // 引文报告
  getScholarReport: '/report/scholarReport', // 人才报告
  getScholarList: '/search/scholar/list', // 获取全局搜索-人才筛选条件（含数量）
};

// 引文报告
export const getCiteReportApi = (params) => {
  return axios.get(Api.getCiteReport, { params });
};

// 人才报告
export const getScholarReportApi = (params) => {
  return axios.get(Api.getScholarReport, { params });
};

// 获取人才列表
export const getScholarListApi = (params, highSearchField, type) => {
  if (type === 'search') {
    return axios.get(
      Api.getScholarList +
      '?highSearchField.name=' +
      highSearchField.name +
      '&highSearchField.orgName=' +
      highSearchField.orgName +
      '&highSearchField.keyword=' +
      highSearchField.keyword,
      { params }
    );
  } else {
    return axios.get(Api.getScholarList, { params });
  }
};
